import { Swiper } from 'swiper/react';
import { PaginationOptions, ScrollbarOptions, Swiper as SwiperClass, SwiperModule, SwiperOptions } from 'swiper/types';

import 'swiper/css';
import 'swiper/css/scrollbar';

type swiperComponentProps = {
	modules: SwiperModule[];
	pagination?: PaginationOptions | boolean;
	navigation?: boolean;
	autoHeight?: boolean;
	spaceBetween?: number;
	slidesPerView?: number;
	breakpoints?: {
		[width: number]: SwiperOptions;
		[ratio: string]: SwiperOptions;
	};
	scrollbar?: ScrollbarOptions | boolean;
	centerInsufficientSlides?: boolean;
	className: string;
	children: JSX.Element | JSX.Element[];
	onSwiper?: (swiper: SwiperClass) => void;
	allowTouchMove?: boolean;
	effect?: 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip' | 'creative' | 'cards';
};

export function SwiperComponent(props: swiperComponentProps): JSX.Element {
	return (
		<Swiper
			modules={props.modules}
			pagination={props.pagination}
			navigation={props.navigation}
			autoHeight={props.autoHeight}
			spaceBetween={props.spaceBetween}
			slidesPerView={props.slidesPerView}
			breakpoints={props.breakpoints}
			scrollbar={props.scrollbar}
			centerInsufficientSlides={props.centerInsufficientSlides}
			onSwiper={props.onSwiper}
			allowTouchMove={props.allowTouchMove}
			effect={props.effect}
			className={props.className}
		>
			{props.children}
		</Swiper>
	);
}
